var map = {
	"./cn/初中/wap.svg": "QCQX",
	"./en/初中/wap.svg": "dy1N"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dyPV";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/初中\/wap\.svg$
// module id = dyPV
// module chunks = 16